import React, { useState, useEffect } from "react";
import {
    Button,
    Card, Collapse, Grid, Paper, Typography, Switch, InputBase
} from "@material-ui/core";
import useStyles from "./styles";
import { SearchOutlined as SearchIcon } from '@material-ui/icons';
import ClearIcon from '@material-ui/icons/Clear';
import { InputBaseField } from '../../components/InputField/InputField';
import { Label } from '../../components/UiElements/UiElements';
import SearchGrid from "./../../components/table/SearchGrid"
import { GetUserInfo } from "../../Services/GetUserInfo";
import { PostDataAPI } from '../../Services/APIService';
import { saveActivlityLogInfo } from '../../components/Common/Extensions';
import Loader from './../../components/Loader/Loader';
import PaymentReciept from './PaymentReciept/PaymentReceiptDialog';
import { withSnackbar } from "./../../components/Message/Alert";
import { ActionDialog } from "./../../components/ActionDialog/ActionDialog";

import jsPDF from 'jspdf';
import html2pdf from 'html2pdf.js';
function PaymentHistory({ ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    Date.prototype.addDays = function (days) {
        this.setDate(this.getDay() + parseInt(days));
        return this;
    };
    const [state, setState] = useState({ fromDate: getDefaultFromDate(), toDate: new Date().toISOString().split('T')[0] });

    function getDefaultFromDate() {
        // Get the current date
        const currentDate = new Date();
        // Calculate six months from the current date
        const sixMonthsLater = new Date();
        sixMonthsLater.setMonth(currentDate.getMonth() - 6);
        return sixMonthsLater.toISOString().split('T')[0];
    }


    function addDays(date, days) {
        date.addDays(days);
        return date.toISOString().split('T')[0];
    }
    //action dialog
    const [actiondialogState, setActionDialogState] = useState({
        showHide: false, type: "confirm", message: "",
    })
    const showActionDialog = (message, type, OnOkCallback, OnCancellCallback) => {
        setActionDialogState(prevState => ({
            ...prevState,
            type: type,
            showHide: true,
            message: message,
            onClickOk: OnOkCallback,
            OnClickCancel: OnCancellCallback
        }));
    }


    const [addcontactDialog, setAddcontactDialog] = useState(false);
    const [lstPaymentHistory, setLstPaymentHistory] = useState([]);
    const handleClose = () => {
        setAddcontactDialog(false)
    }

    const [isLoading, setIsLoading] = useState(false);
    const [isPaymentReceiptDialogOpen, setPaymentReceiptDialogOpen] = useState(false);
    const [receiptHTMLToLoad, setReceiptHTMLToLoad] = useState({});
    const openContactDialog = () => {
        setAddcontactDialog(true)
    }
    const handleChange = (e) => {
        const { name, value, checked } = e.target;

        setState((prevState) => ({
            ...prevState,
            [name]: value,

        }));
    }
    const handleSwitchChange = (event) => {
        setState({ ...state, [event.target.name]: event.target.checked });
    };
    let user_info = JSON.parse(GetUserInfo());
    const [accountNumber] = useState(user_info.user.accountNumber);
    const [customerID] = useState(user_info.user.customerID);


    const getPaymentHistory = () => {
        if (!state.fromDate) {
            showMessage("Error", "Please select from date", "error", 3000);
            return;
        }
        else if (!state.toDate) {
            showMessage("Error", "Please select to date", "error", 3000);
            return;
        }
        else if (state.fromDate > state.toDate) {
            showMessage("Error", "From date cannot be greater than to date", "error", 3000);
            return;
        }
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const fromDate = new Date(state.fromDate);
        fromDate.setHours(0, 0, 0, 0);

        const toDate = new Date(state.toDate);
        toDate.setHours(0, 0, 0, 0);

        if (fromDate > today && toDate > today) {
            showMessage("Error", "From Date and To Date both can't be from future", "error", 3000);
            return;
        }
        else {
            var obj = {
                accountNumber: accountNumber,
                fromDate: state.fromDate,
                toDate: state.toDate
            };
            setIsLoading(true);
            PostDataAPI("telispire/getPaymentHistory", obj, true).then((result) => {
                setIsLoading(false);
                if (result.success && result.data != null) {
                    const filteredItems = result.data.filter(item => item.amount !== 0);
                    setLstPaymentHistory(filteredItems);

                }
                else {

                    showMessage("Error", "We're currently experiencing a temporary issue retrieving the information you requested. Please try again later.", "error", 3000);
                }
                handleUpdate();

            })
        }

    }
    function generatePDFFromHTML(receiptHtml, key) {
        if (key == 'ViewReceipt')
            viewReceipt(receiptHtml);
        else if (key == 'ViewPDF')
            viewPDF(receiptHtml);
        else if (key == 'PrintReceipt')
            printReceipt(receiptHtml);
        else if (key == 'EmailReceipt')
            emailReceipt(receiptHtml);
    }
    const viewReceipt = (receiptHtml) => {
        setReceiptHTMLToLoad(receiptHtml);
        setPaymentReceiptDialogOpen(true);
    }
    const viewPDF = (receiptHtml) => {
        var doc = new jsPDF();
        setIsLoading(true);
        doc.html(receiptHtml, {
            callback: function (doc) {
                setIsLoading(false);
                // Save the PDF
                doc.save('document-html.pdf');
            },
            margin: [10, 10, 10, 10],
            autoPaging: 'text',
            x: 0,
            y: 0,
            width: 190, //target width in the PDF document
            windowWidth: 675 //window width in CSS pixels
        });
    }

    const printReceipt = (receiptHtml) => {
        setIsLoading(true);
        const printWindow = window.open('', '_blank');
        printWindow.document.write(receiptHtml);
        printWindow.document.close();
        printWindow.onload = () => {
            setIsLoading(false);
            printWindow.print();
        };
    }

    const emailReceipt = (receiptHtml) => {
        showActionDialog("Are you sure you want to email this receipt?", "confirm", function () {
            var doc = new jsPDF();
            setIsLoading(true);
            doc.html(receiptHtml, {
                callback: function (doc) {
                    setIsLoading(false);
                    // Convert the PDF content to a Blob
                    const pdfBlob = doc.output('blob');
                    // Convert the Blob to a File object
                    const pdfFile = new File([pdfBlob], 'Receipt.pdf', { type: 'application/pdf' });
                    // Create a FormData object and append the File
                    const formData = new FormData();
                    formData.append("customerId", customerID);
                    formData.append('paymentHistoryFile', pdfFile);
                    //-------------------- To Save File
                    setIsLoading(true);
                    PostDataAPI("telispire/emailPaymentHistoryReceipt", formData).then((result) => {
                        if (result.success) {
                            showMessage("Success", "Please check your email for payment receipt", "success", 3000);
                        }
                        else {
                            showMessage("Error", "Please try again.", "error", 3000);
                        }
                        setIsLoading(false);
                    })
                },
                margin: [10, 10, 10, 10],
                autoPaging: 'text',
                x: 0,
                y: 0,
                width: 190, //target width in the PDF document
                windowWidth: 675 //window width in CSS pixels
            });
        });
    }

    const openPdf = (pdfLink) => {
        window.open(pdfLink, '_blank', 'noopener,noreferrer');
    };
    const getReceiptActionInfo = (key) => {
        if (key == 'ViewPDF')
            return { activity: "Receipt PDF Viewed", actionText: "opened payment receipt PDF" };
        else if (key == 'PrintReceipt')
            return { activity: "Receipt Printed", actionText: "printed payment receipt" };
        else if (key == 'EmailReceipt')
            return { activity: "Receipt Email Requested", actionText: "requested payment receipt email" };

        return { activity: "Receipt Viewed", actionText: "viewed payment receipt" };
    }
    const logReceiptAction = (key, item, outcome) => {
        const receiptAction = getReceiptActionInfo(key);
        const details = [
            `User ${receiptAction.actionText}`,
            item && item.id ? `invoice # ${item.id}` : "",
            item && item.formattedAmount ? `amount ${item.formattedAmount}` : "",
            item && item.date ? `payment date ${item.date}` : "",
            item && item.description ? `description ${item.description}` : "",
            outcome
        ].filter(Boolean).join(", ");

        saveActivlityLogInfo("Payment History", receiptAction.activity, details, accountNumber, customerID);
    }
    const handleActionClick = (key, item) => {
        if (key == 'ViewPDF' || key == 'PrintReceipt' || key == 'ViewReceipt') {
            if (!item.invoicePDFUrl) {
                logReceiptAction(key, item, "receipt PDF was not available");
                showMessage("Alert", "Receipt not saved. Please contact customer support.", "warning", 3000);
            }
            else {
                logReceiptAction(key, item, "receipt PDF opened");
                openPdf(item.invoicePDFUrl);
            }
        } else {
            if (item.receiptHTML) {
                logReceiptAction(key, item, "receipt HTML was available");
                generatePDFFromHTML(item.receiptHTML, key);
            } else {
                logReceiptAction(key, item, "receipt HTML was not available");
                showMessage("Error", "No payment receipt exists", "error", 3000);
            }
        }

    }


    const [isUpdate, setIsUpdate] = useState(false);
    const handleUpdate = () => {
        setIsUpdate(!isUpdate);
    }

    const [searchFilter, setValue] = useState('');
    const handleSearch = (e) => {
        const currValue = e.target.value;
        if (currValue.trim().length > 0 || currValue == '') {
            setValue(currValue);
            handleUpdate()
        }
    }
    // Function to clear the input field
    const handleClearInput = (name) => {
        setValue('');
        handleUpdate();
    };

    useEffect(() => {
        getPaymentHistory();
    }, []);
    return (
        <>
            {isLoading ? <Loader></Loader> : ''}
            <div className={classes.appBarSpacer} />
            <div className={classes.header}>
                <Typography component="h2">Payment History</Typography>
            </div>
            <Grid className={classes.container} style={{ padding: '5px 10px' }}>

                <Grid container style={{ margin: '0px 0px 10px 5px' }}>

                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12} >
                        <div className="d-flex">

                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12} >
                                <Grid container className="d-flex1">
                                    <Grid item xl={2} lg={2} md={2} sm={2} xs={2}>
                                        <Label title="From" style={{ margin: '0px 0px 0px 0px' }} />
                                    </Grid>
                                    <Grid item xl={10} lg={10} md={10} sm={10} xs={10} >
                                        <InputBaseField
                                            name="fromDate"
                                            placeholder="From Date"
                                            type="date"
                                            value={state.fromDate}
                                            onChange={handleChange} />
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12} >
                                <Grid container className="d-flex1 ">
                                    <Grid item xl={2} lg={2} md={2} sm={2} xs={2} >
                                        <Label title="To" />
                                    </Grid>
                                    <Grid item xl={10} lg={10} md={10} sm={10} xs={10} >
                                        <InputBaseField
                                            name="toDate"
                                            placeholder="To Date"
                                            type="date"
                                            value={state.toDate}
                                            onChange={handleChange} />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xl={6} lg={6} md={6} sm={12} xs={12} className="d-flex1">
                                <Button style={{ margin: window.isMobileView ? '0px 0px 10px 0px' : '0px 0px 10px 5px' }} className={classes.changeBtn} onClick={getPaymentHistory}>Search</Button>
                            </Grid>

                        </div>

                    </Grid>

                    <Grid item xl={6} lg={6} md={6} sm={12} xs={12} className={classes.alignItemsRight}>
                        <div className={classes.gridActions} style={{ marginRight: '7px' }} >
                            <InputBase
                                value={searchFilter}
                                placeholder="Search"
                                className="grid-search-input"
                                endAdornment={searchFilter ? <ClearIcon style={{ cursor: 'pointer' }} onClick={() => { handleClearInput('search') }} /> : ''}
                                startAdornment={<SearchIcon />}
                                onChange={handleSearch}
                            />
                        </div>
                    </Grid>
                </Grid>



                {/* {window.isMobileView ?
                    <>
                        {lstPaymentHistory.length > 0 ?
                            <div>
                                {lstPaymentHistory.map((item, i) => {
                                    return (
                                        <>
                                            <div className={classes.mobileTableList}>

                                                <div>
                                                    <h4>Amount</h4>
                                                    <p>{item.amount} </p>
                                                </div>
                                                <div>
                                                    <h4>Payment Date</h4>
                                                    {item.date}
                                                </div>
                                                <div>
                                                    <h4>Payment Type</h4>
                                                    {item.description}
                                                </div>
                                                

                                            </div>

                                        </>
                                    )
                                })}
                            </div> : <div className={classes.mobileTableList}>
                                <div className="textCenter"> No payment history found</div>
                            </div>}
                    </> : */}
                <Grid row className={classes.table}>
                    <SearchGrid
                        columns="paymentHistory"
                        list={lstPaymentHistory}
                        noRecordMsg="No record exists"
                        onActionClick={handleActionClick}
                        Icon={true}
                        isUpdate={isUpdate}
                        filter={searchFilter}
                    ></SearchGrid>
                </Grid>


            </Grid >

            <ActionDialog
                type={actiondialogState.type}
                message={actiondialogState.message}
                actiondialogOpenClose={actiondialogState.showHide}
                onSubmit={actiondialogState.onClickOk}
                onCancel={() =>
                    setActionDialogState(prevState => ({
                        ...prevState, showHide: false
                    }))
                }
                onClose={() => setActionDialogState(prevState => ({
                    ...prevState, showHide: false
                }))

                }
            />

            {isPaymentReceiptDialogOpen ?
                <PaymentReciept
                    dialogOpenClose={isPaymentReceiptDialogOpen}
                    handleClose={() => setPaymentReceiptDialogOpen(false)}
                    receiptHtml={receiptHTMLToLoad}
                ></PaymentReciept>
                : null}
        </>
    )
}
export default withSnackbar(PaymentHistory);
